export interface ConfirmOptions {
  message: string;
  title?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
}

export interface ConfirmRequest extends ConfirmOptions {
  id: number;
  resolve: (value: boolean) => void;
}

type Listener = () => void;

let current: ConfirmRequest | null = null;
let queue: ConfirmRequest[] = [];
let nextId = 1;
const listeners = new Set<Listener>();

function emit(): void {
  for (const listener of listeners) listener();
}

export function subscribe(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function getSnapshot(): ConfirmRequest | null {
  return current;
}

export function requestConfirm(options: ConfirmOptions): Promise<boolean> {
  return new Promise<boolean>((resolve) => {
    const req: ConfirmRequest = { ...options, id: nextId++, resolve };
    if (current) {
      queue.push(req);
    } else {
      current = req;
      emit();
    }
  });
}

export function resolveConfirm(value: boolean): void {
  if (!current) return;
  current.resolve(value);
  current = queue.shift() ?? null;
  emit();
}

/** Test-only reset. */
export function __resetConfirm(): void {
  current = null;
  queue = [];
  nextId = 1;
  listeners.clear();
}
